// /home/oh33090489/real-estate-app/frontend/src/utils/addressGroup.js

export function getAddressKey(item) {
  if (!item) return null;

// =========== 제미나이 제안 (수정) 2026.01.18
// 1) 원본 주소 선택 (지번 우선)
  const raw = item.jibunAddress || item.roadAddress || item.jibun || "";
  if (!raw) return null;

  // 2) 호 / 층 / 동 정보 제거 (건물 단위까지만 그룹핑하기 위함)
  // KakaoMap.js의 normalizeBuildingAddress와 로직 통합
  return raw
    .replace(/\s*\d+동\s*\d+호.*$/, "")
    .replace(/\s*\d+호.*$/, "")
    .replace(/\s*\d+층.*$/, "")
    .trim();
// =========== 제미나이 제안 (수정) 2026.01.18

}

export function groupByAddress(items = []) {
  if (!Array.isArray(items) || items.length === 0) return {};

  const map = {};
  for (const it of items) {
    if (!it) continue;
    const key = getAddressKey(it);
    if (!key) continue;

    if (!map[key]) {
      map[key] = {
        key,
        lat: Number(it.lat) || null,
        lng: Number(it.lng) || null,
        items: [],
      };
    }
    map[key].items.push(it);
  }
  return map;
}
